module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.group_index !== undefined && _vm.groups[_vm.group_index]) ? _c('div', _vm._l((_vm.groups[_vm.group_index].parameters), function(param, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.$emit('input', index)
        }
      }
    }, [_c('div', {
      staticClass: "value-card",
      class: {
        active: _vm.value == index
      }
    }, [(false) ? _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "alt": " ",
        "src": param.picture
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_c('div', {
      staticClass: "c-title"
    }, [_vm._v("\n          " + _vm._s(param.name) + "\n          "), (_vm.attributes[param.code] && _vm.attributes[param.code].price > 0) ? _c('span', {
      staticClass: "supplement"
    }, [_vm._v("+" + _vm._s(_vm.attributes[param.code].price) + " €")]) : _vm._e()]), _vm._v(" "), (_vm.attributes[param.code]) ? _c('div', [(_vm.attributes[param.code] instanceof Object) ? _c('span', [_vm._v(_vm._s(_vm.attributes[param.code].name))]) : _c('span', [_vm._v(_vm._s(_vm.attributes[param.code]))])]) : _vm._e()])])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c82e52ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Designer/AttributeSelector.vue
// module id = 509
// module chunks = 1